enum Topics {
  boilerControls = 'boilerControls',
  centralHeating = 'centralHeating',
  plumbing = 'plumbing',
  drains = 'drains',
  electrics = 'electrics',
  pestsSecurity = 'pestsSecurity',
}

export { Topics };
